import { defineMessages } from 'react-intl';

export default defineMessages({

    warningMsg: {
        id: 'gateway.directives.ho.policy change.warning Policy Message',
        defaultMessage: 'Our records indicate that you do not have servicing rights on this policy. Please contact your Underwriter for further assistance'
    }
});
